import React from 'react';
import { Card, CardContent, CardMedia, Button, Typography, CardActions, Box } from '@mui/material';

const PoseCard = ({ pose, onStartRecording }) => {
  return (
    <Card 
      sx={{
        maxWidth: 345,
        m: 2,
        borderRadius: 4,
        background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
        transition: 'all 0.3s ease-in-out',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.06)',
        border: '1px solid rgba(255, 255, 255, 0.18)',
        '&:hover': {
          transform: 'translateY(-5px)',
          boxShadow: '0 12px 48px rgba(0, 0, 0, 0.1)',
        }
      }}
    >
      <Box sx={{
        position: 'relative',
        '&::after': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.4) 100%)',
          borderRadius: '16px 16px 0 0',
          opacity: 0,
          transition: 'opacity 0.3s ease-in-out',
        },
        '&:hover::after': {
          opacity: 1,
        }
      }}>
        <CardMedia
          component="img"
          height="220"
          image={pose.image}
          alt={pose.name}
          sx={{
            borderRadius: '16px 16px 0 0',
            objectFit: 'cover',
          }}
        />
      </Box>
      <CardContent sx={{ p: 3 }}>
        <Typography 
          gutterBottom 
          variant="h5" 
          component="div"
          sx={{
            fontWeight: 600,
            background: 'linear-gradient(45deg, #2196F3, #1976D2)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            mb: 2
          }}
        >
          {pose.name}
        </Typography>
        <Typography 
          variant="body2" 
          sx={{
            color: 'text.secondary',
            lineHeight: 1.6,
            mb: 2
          }}
        >
          {pose.description}
        </Typography>
      </CardContent>
      <CardActions sx={{ p: 2, pt: 0 }}>
        <Button 
          size="large" 
          variant="contained" 
          fullWidth 
          onClick={() => onStartRecording(pose.id)}
          sx={{
            borderRadius: 3,
            py: 1.5,
            background: 'linear-gradient(45deg, #2196F3, #1976D2)',
            boxShadow: '0 4px 16px rgba(33, 150, 243, 0.3)',
            transition: 'all 0.3s ease-in-out',
            '&:hover': {
              background: 'linear-gradient(45deg, #1976D2, #1565C0)',
              boxShadow: '0 6px 20px rgba(33, 150, 243, 0.4)',
              transform: 'translateY(-2px)'
            }
          }}
        >
          Start Recording
        </Button>
      </CardActions>
    </Card>
  );
};

export default PoseCard;
